module.exports = __webpack_public_path__ + "img/04_off.90f4e9ed.png";